import { action, ActionType } from "typesafe-actions";
import { IError } from "../../../redux/actions/errorHandlingAction";
import { WidenSignature } from "../types/dam-signature-response.interface";

export enum DamActions {
  Init = "Dam/Init",
  FetchSignature = "Dam/FetchSignature",
  FetchSignatureSuccess = "Dam/FetchSignatureSuccess",
  FetchSignatureFailure = "Dam/FetchSignatureFailure",
}

export const init = () => action(DamActions.Init);
export const fetchSignature = () => action(DamActions.FetchSignature);
export const fetchSignatureSuccess = (signature: WidenSignature, date: Date) =>
  action(DamActions.FetchSignatureSuccess, { signature, date });
export const fetchSignatureFailure = (error: IError) =>
  action(DamActions.FetchSignatureFailure, error);

const actionCreators = {
  init,
  fetchSignature,
  fetchSignatureSuccess,
  fetchSignatureFailure,
};

export type DamActionType = ActionType<typeof actionCreators>;
